import * as React from "react";

/**
 * This abstraction over react CreateContext is useful to avoid cheating over
 * typescript using typecasting and also automagically creating a customHook that
 * consumes the context created
 */
export function createContext<A extends {} | null>() {
    const ctx = React.createContext<A | undefined>(undefined);

    const useContext = () => {
        const c = React.useContext(ctx);
        if (c === undefined) {
            throw new Error("useContext must be inside a Provider with a value");
        }
        return c;
    };
    return [useContext, ctx.Provider] as const;
}
